/* YAMAKITS FAVORITES v2 (sept. 2026)
   Favoris côté client (localStorage « yamakits_favorites_v1 »). API globale : window.ykFav
   { add(handle, meta), remove(handle), toggle(handle, meta), has(handle), count(), list(), clear(),
     open(), close(), isOpen(), render(), refresh(), addToCart(handle), addAll() }.
   Évènement : document « ykfav:change » ({detail:{count}}) après chaque modification.

   CONTRAT header (sections/header.liquid) :
   - clic sur [data-ykfav-open]  → preventDefault + ouverture du tiroir ;
   - clic sur [data-ykfav-close] → fermeture ;
   - [data-ykfav-count] / <ykfav-count> : texte = nombre de favoris, mis à jour à l'init et à chaque
     « ykfav:change », classe « is-empty » posée quand le compteur vaut 0 (retirée sinon).
   Les éléments ajoutés au DOM après l'init (header rendu plus tard, sections rechargées) sont câblés par un
   MutationObserver.

   Panier : l'ajout passe par window.ykCart (assets/yk-cart.js) avec le même format de lignes que la pop-up
   d'ajout du panier (taille en propriété « Taille », add-ons flocage / short / version Player liés par
   _yk_ref + _yk_addon, ids et prix lus dans window.YK_CART_CFG). Repli : /cart/add.js puis ykCart.refresh().
*/
(function () {
  if (window.ykFav) return;

  var STORAGE_KEY = 'yamakits_favorites_v1';
  var MAX_ITEMS = 200;
  var SIZES = ['S', 'M', 'L', 'XL', '2XL'];
  var COLLECTION_URL = '/collections/maillot-de-football';
  /* produits techniques (suppléments, options) : jamais en favoris — même règles que snippets/yk-hidden-product.liquid */
  var HIDDEN_RE = /^(supplement-|option-set-|version-player|badge-competition|short-assorti|ajouter-le-short$|flocage-personnalise$|numero(-\d+)?$)/;

  var productCache = {}; // handle -> product json (/products/<handle>.js)
  var inFlight = {};     // handle -> Promise
  var openPanels = {};   // handle -> true (panneau « Options » déplié)
  var busy = {};         // handle -> true (ajout au panier en cours)
  var lastFocus = null;
  var clearArmed = 0;

  /* ---------------- utilitaires ---------------- */
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function cssEscape(s) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(s);
    return String(s).replace(/[^a-zA-Z0-9_-]/g, function (c) { return '\\' + c; });
  }
  function money(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function cartCfg() { return window.YK_CART_CFG || {}; }
  function cartIds() { return cartCfg().ids || {}; }
  function cartPrices() {
    var p = cartCfg().prices || {};
    return { floc: +p.floc || 99, short: +p.short || 2199, vplayer: +p.vplayer || 499 };
  }
  function localePrefix() {
    var m = (window.location.pathname || '').match(/^\/(en|ar|fr)(\/|$)/);
    return (m && m[1] !== 'fr') ? '/' + m[1] : '';
  }
  function productUrl(handle) { return localePrefix() + '/products/' + encodeURIComponent(handle); }
  function isHiddenHandle(handle) { return HIDDEN_RE.test(String(handle || '').toLowerCase()); }
  /* URL d'image sûre : https, et largeur CDN demandée (évite les fichiers pleine taille dans le tiroir) */
  function normImage(src, width) {
    src = String(src || '').trim();
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    else if (src.indexOf('http://') === 0) src = 'https://' + src.slice(7);
    if (width && /cdn\.shopify\.com/.test(src) && !/[?&]width=/.test(src)) {
      src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }
    return src;
  }
  function newRef() { return 'YK-' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 5).toUpperCase(); }

  function defaultConfig() {
    return { sz: '', floc: false, name: '', num: '', sub: '', short: false, shortSz: '', vplayer: false };
  }
  function normConfig(c) {
    var cfg = Object.assign({}, defaultConfig(), c || {});
    /* anciens favoris (v1) : joueur officiel → nom + numéro */
    if (c && c.tab === 'players' && c.player && c.player.name) {
      cfg.name = cfg.name || c.player.name;
      cfg.num = cfg.num || String(c.player.n || '');
      cfg.floc = true;
    }
    delete cfg.tab; delete cfg.player;
    if (SIZES.indexOf(cfg.sz) === -1) cfg.sz = '';
    if (SIZES.indexOf(cfg.shortSz) === -1) cfg.shortSz = '';
    if (!cfg.floc) { cfg.name = ''; cfg.num = ''; cfg.sub = ''; }
    return cfg;
  }

  /* Lit la configuration choisie sur la fiche produit (configurateur yk-pdp-configurator) au moment du clic */
  function readPdpConfig() {
    if (!/\/products\//.test(window.location.pathname)) return null;
    if (!document.querySelector('#ykAddBtn')) return null;
    var cfg = defaultConfig();
    var szOn = document.querySelector('#ykSizes .yk-sz-btn.on');
    if (szOn) cfg.sz = szOn.dataset.sz || '';
    var flocSwitch = document.querySelector('#ykFlocSwitch');
    cfg.floc = !!(flocSwitch && flocSwitch.classList.contains('on'));
    if (cfg.floc) {
      var tabOn = document.querySelector('#ykTabs .yk-tab.on');
      var playerOn = document.querySelector('#ykPlayersGrid .yk-player.on');
      if (tabOn && tabOn.dataset.tab === 'players' && playerOn) {
        cfg.name = playerOn.dataset.name || '';
        cfg.num = playerOn.dataset.n || '';
      } else {
        var nameEl = document.getElementById('ykName'), numEl = document.getElementById('ykNum'), subEl = document.getElementById('ykSub');
        if (nameEl) cfg.name = (nameEl.value || '').trim();
        if (numEl) cfg.num = (numEl.value || '').trim();
        if (subEl) cfg.sub = (subEl.value || '').trim();
      }
    }
    var shortSwitch = document.querySelector('#ykShortSwitch');
    cfg.short = !!(shortSwitch && shortSwitch.classList.contains('on'));
    var shortSzOn = document.querySelector('#ykShortSizes .yk-sz-btn.on');
    if (shortSzOn) cfg.shortSz = shortSzOn.dataset.sz || '';
    if (cfg.short && !cfg.shortSz) cfg.shortSz = cfg.sz;
    var vpSwitch = document.querySelector('#ykVPlayerSwitch');
    cfg.vplayer = !!(vpSwitch && vpSwitch.classList.contains('on'));
    return normConfig(cfg);
  }

  /* ---------------- stockage ---------------- */
  function readStore() {
    var raw;
    try { raw = localStorage.getItem(STORAGE_KEY); } catch (e) { return []; }
    if (!raw) return [];
    var parsed;
    try { parsed = JSON.parse(raw); } catch (e) { return []; }
    if (!Array.isArray(parsed)) return [];
    var seen = {}, out = [];
    for (var i = 0; i < parsed.length; i++) {
      var e = parsed[i];
      if (!e || typeof e.handle !== 'string') continue;
      var h = e.handle.trim().toLowerCase();
      if (!h || seen[h] || isHiddenHandle(h)) continue; // doublons + produits techniques ignorés
      seen[h] = true;
      out.push({
        handle: h,
        addedAt: +e.addedAt || 0,
        title: typeof e.title === 'string' ? e.title : '',
        image: normImage(e.image),
        price: typeof e.price === 'number' ? e.price : null,
        cmp: typeof e.cmp === 'number' ? e.cmp : null,
        config: normConfig(e.config)
      });
    }
    return out;
  }
  function writeStore(list) {
    try {
      if (list.length > MAX_ITEMS) list = list.slice(0, MAX_ITEMS);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      return true;
    } catch (e) { return false; }
  }
  function findEntry(list, handle) {
    for (var i = 0; i < list.length; i++) if (list[i].handle === handle) return list[i];
    return null;
  }
  function emit() {
    try { document.dispatchEvent(new CustomEvent('ykfav:change', { detail: { count: count() } })); } catch (e) {}
  }

  /* ---------------- API ---------------- */
  function has(handle) { return !!(handle && findEntry(readStore(), String(handle).toLowerCase())); }
  function count() { return readStore().length; }
  function list() { return readStore(); }

  function add(handle, meta) {
    handle = String(handle || '').trim().toLowerCase();
    if (!handle || isHiddenHandle(handle)) return false;
    var l = readStore();
    if (findEntry(l, handle)) return false;
    var p = productCache[handle];
    l.unshift({
      handle: handle,
      addedAt: Date.now(),
      title: (meta && meta.title) || (p && p.title) || '',
      image: normImage((meta && meta.image) || (p && p.featured_image) || ''),
      price: p && typeof p.price === 'number' ? p.price : null,
      cmp: p && typeof p.compare_at_price === 'number' ? p.compare_at_price : null,
      config: normConfig(meta && meta.config)
    });
    writeStore(l);
    emit();
    return true;
  }
  function remove(handle) {
    handle = String(handle || '').trim().toLowerCase();
    var l = readStore();
    var next = l.filter(function (e) { return e.handle !== handle; });
    if (next.length === l.length) return false;
    writeStore(next);
    delete openPanels[handle];
    emit();
    return true;
  }
  function toggle(handle, meta) { return has(handle) ? (remove(handle), false) : add(handle, meta); }
  function clear() { writeStore([]); openPanels = {}; emit(); }

  /* mise à jour silencieuse (sans re-render) de la config ou des métadonnées d'un favori */
  function patchEntry(handle, patch, isConfig) {
    var l = readStore(), e = findEntry(l, handle);
    if (!e) return false;
    if (isConfig) e.config = normConfig(Object.assign({}, e.config, patch));
    else Object.assign(e, patch);
    writeStore(l);
    return true;
  }
  function getConfig(handle) {
    var e = findEntry(readStore(), handle);
    return e ? e.config : defaultConfig();
  }

  /* ---------------- produit ---------------- */
  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    if (inFlight[handle]) return inFlight[handle];
    var url = localePrefix() + '/products/' + encodeURIComponent(handle) + '.js';
    inFlight[handle] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) { var e = new Error('product ' + r.status); e.status = r.status; throw e; }
        return r.json();
      })
      .then(function (p) {
        productCache[handle] = p;
        delete inFlight[handle];
        /* métadonnées mémorisées → le prochain rendu est instantané, même hors ligne */
        patchEntry(handle, {
          title: p.title || '',
          image: normImage(p.featured_image || (p.images && p.images[0]) || ''),
          price: typeof p.price === 'number' ? p.price : null,
          cmp: typeof p.compare_at_price === 'number' ? p.compare_at_price : null
        });
        return p;
      })
      .catch(function (err) { delete inFlight[handle]; throw err; });
    return inFlight[handle];
  }
  function pickVariant(product, sz) {
    if (!product || !product.variants || !product.variants.length) return null;
    var vs = product.variants, i;
    if (sz) {
      for (i = 0; i < vs.length; i++) {
        var o = String(vs[i].option1 || vs[i].title || '').trim().toUpperCase();
        if (o === sz.toUpperCase()) return vs[i];
      }
    }
    for (i = 0; i < vs.length; i++) if (vs[i].available) return vs[i];
    return vs[0];
  }
  function itemTotal(entry, product, cfg) {
    var base = product && typeof product.price === 'number' ? product.price : (typeof entry.price === 'number' ? entry.price : 0);
    var P = cartPrices(), total = base;
    if (cfg.floc) { if (cfg.name) total += P.floc; if (cfg.num) total += P.floc; if (cfg.sub) total += P.floc; }
    if (cfg.short) total += P.short;
    if (cfg.vplayer) total += P.vplayer;
    return total;
  }
  function optionsSummary(cfg) {
    var bits = [];
    if (cfg.floc && (cfg.name || cfg.num || cfg.sub)) bits.push('Flocage');
    if (cfg.short) bits.push('Short');
    if (cfg.vplayer) bits.push('Player');
    return bits.length ? bits.join(' · ') : 'Aucune option';
  }

  /* ---------------- rendu ---------------- */
  function chipsHtml(handle, attr, current) {
    return SIZES.map(function (s) {
      return '<button type="button" class="ykf-chip' + (current === s ? ' on' : '') + '" ' + attr + '="' + s + '" data-ykf-h="' + escapeHtml(handle) + '" aria-pressed="' + (current === s ? 'true' : 'false') + '">' + s + '</button>';
    }).join('');
  }
  function switchHtml(attr, handle, on, label) {
    return '<button type="button" class="ykf-sw' + (on ? ' on' : '') + '" role="switch" aria-checked="' + (on ? 'true' : 'false') + '" aria-label="' + escapeHtml(label) + '" ' + attr + '="' + escapeHtml(handle) + '"><span class="ykf-sw__k"></span></button>';
  }
  function itemHtml(entry, product) {
    var h = entry.handle, cfg = entry.config;
    var title = (product && product.title) || entry.title || h;
    var image = normImage((product && product.featured_image) || entry.image, 160);
    var price = product && typeof product.price === 'number' ? product.price : entry.price;
    var cmp = product && typeof product.compare_at_price === 'number' ? product.compare_at_price : entry.cmp;
    var available = product ? !!product.available : true;
    var total = itemTotal(entry, product, cfg);
    var P = cartPrices();
    var url = productUrl(h);
    var needSize = !cfg.sz;
    var isBusy = !!busy[h];
    var addLabel = !available ? 'Épuisé' : (needSize ? 'Choisir une taille' : 'Ajouter au panier' + (total > 0 ? ' · ' + money(total) : ''));
    var panelOpen = !!openPanels[h];
    var priceHtml = '';
    if (typeof price === 'number') {
      priceHtml = '<p class="ykf-item__price"><b>' + money(price) + '</b>' + (typeof cmp === 'number' && cmp > price ? '<s>' + money(cmp) + '</s>' : '') + '</p>';
    } else if (!product) {
      priceHtml = '<p class="ykf-item__price ykf-item__price--ph"><b>&nbsp;</b></p>';
    }
    return ''
      + '<div class="ykf-item' + (isBusy ? ' busy' : '') + '" data-ykf-handle="' + escapeHtml(h) + '">'
      +   '<div class="ykf-item__main">'
      +     '<a class="ykf-item__imglink" href="' + escapeHtml(url) + '" tabindex="-1" aria-hidden="true">'
      +       (image ? '<img class="ykf-item__img" src="' + escapeHtml(image) + '" alt="" width="70" height="88" loading="lazy" decoding="async">' : '<span class="ykf-item__img ykf-item__img--ph"></span>')
      +     '</a>'
      +     '<div class="ykf-item__info">'
      +       '<div class="ykf-item__row">'
      +         '<a class="ykf-item__title" href="' + escapeHtml(url) + '">' + escapeHtml(title) + '</a>'
      +         '<button type="button" class="ykf-item__del" data-ykf-remove="' + escapeHtml(h) + '" aria-label="Retirer des favoris" title="Retirer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg></button>'
      +       '</div>'
      +       priceHtml
      +       '<a class="ykf-item__link" href="' + escapeHtml(url) + '">Voir la fiche<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M7.5 3.75L13.75 10L7.5 16.25" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></a>'
      +     '</div>'
      +   '</div>'
      +   '<div class="ykf-blk ykf-blk--size">'
      +     '<p class="ykf-lab">Taille' + (needSize ? ' <span class="ykf-lab__hint">à choisir</span>' : '') + '</p>'
      +     '<div class="ykf-chips">' + chipsHtml(h, 'data-ykf-size', cfg.sz) + '</div>'
      +   '</div>'
      +   '<button type="button" class="ykf-item__edit" data-ykf-panel="' + escapeHtml(h) + '" aria-expanded="' + (panelOpen ? 'true' : 'false') + '">'
      +     '<svg class="ykf-item__pen" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M5.79 13.5H3a.5.5 0 0 1-.5-.5v-2.79a.5.5 0 0 1 .15-.36L10.35 2.15a.5.5 0 0 1 .71 0l2.79 2.79a.5.5 0 0 1 0 .71L6.15 13.35a.5.5 0 0 1-.36.15Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.5 4 12 7.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>'
      +     '<span class="ykf-item__edit-l">Options du maillot</span>'
      +     '<span class="ykf-item__sum">' + escapeHtml(optionsSummary(cfg)) + '</span>'
      +     '<svg class="ykf-chev" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M7.5 3.75L13.75 10L7.5 16.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      +   '</button>'
      +   '<div class="ykf-panel"' + (panelOpen ? '' : ' hidden') + '>'
      +     '<div class="ykf-xrow">'
      +       '<span class="ykf-xrow__l">Flocage</span><span class="ykf-pill">+' + money(P.floc) + ' / élément</span>'
      +       switchHtml('data-ykf-floc-switch', h, cfg.floc, 'Flocage')
      +     '</div>'
      +     '<div class="ykf-floc"' + (cfg.floc ? '' : ' hidden') + '>'
      +       '<div class="ykf-floc__row">'
      +         '<input type="text" class="ykf-input" data-ykf-floc-field="name" data-ykf-h="' + escapeHtml(h) + '" value="' + escapeHtml(cfg.name) + '" maxlength="12" placeholder="Nom" autocomplete="off" autocapitalize="characters">'
      +         '<input type="text" class="ykf-input ykf-input--num" data-ykf-floc-field="num" data-ykf-h="' + escapeHtml(h) + '" value="' + escapeHtml(cfg.num) + '" maxlength="2" inputmode="numeric" placeholder="N°" autocomplete="off">'
      +       '</div>'
      +       '<input type="text" class="ykf-input" data-ykf-floc-field="sub" data-ykf-h="' + escapeHtml(h) + '" value="' + escapeHtml(cfg.sub) + '" maxlength="12" placeholder="Nom sous le numéro" autocomplete="off" autocapitalize="characters">'
      +     '</div>'
      +     '<div class="ykf-xrow">'
      +       '<span class="ykf-xrow__l">Short assorti</span><span class="ykf-pill">+' + money(P.short) + '</span>'
      +       switchHtml('data-ykf-short-switch', h, cfg.short, 'Short assorti')
      +     '</div>'
      +     (cfg.short ? '<div class="ykf-chips ykf-chips--short">' + chipsHtml(h, 'data-ykf-short-size', cfg.shortSz) + '</div>' : '')
      +     '<div class="ykf-xrow ykf-xrow--last">'
      +       '<span class="ykf-xrow__l">Version Player</span><span class="ykf-pill">+' + money(P.vplayer) + '</span>'
      +       switchHtml('data-ykf-vplayer-switch', h, cfg.vplayer, 'Version Player')
      +     '</div>'
      +   '</div>'
      +   '<div class="ykf-item__foot">'
      +     '<button type="button" class="ykf-btn-black ykf-add" data-ykf-add="' + escapeHtml(h) + '"' + ((!available || needSize || isBusy) ? ' disabled' : '') + '>' + escapeHtml(addLabel) + '</button>'
      +     '<p class="ykf-item__err" hidden></p>'
      +   '</div>'
      + '</div>';
  }
  function emptyHtml() {
    return ''
      + '<div class="ykf-empty">'
      +   '<span class="ykf-empty__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></span>'
      +   '<h3 class="ykf-empty__t">Aucun favori pour l’instant</h3>'
      +   '<p class="ykf-empty__p">Touche le cœur sur un maillot pour le retrouver ici, avec ta taille et tes options.</p>'
      +   '<a href="' + COLLECTION_URL + '" class="ykf-btn-black ykf-empty__cta">Voir les maillots</a>'
      + '</div>';
  }
  function renderFoot(entries) {
    var foot = document.getElementById('ykfFoot');
    if (!foot) return;
    if (!entries.length) { foot.hidden = true; foot.innerHTML = ''; return; }
    foot.hidden = false;
    foot.innerHTML = ''
      + (entries.length >= 2 ? '<button type="button" class="ykf-btn-black ykf-foot__all" data-ykf-add-all>Tout ajouter au panier <span class="ykf-foot__n">' + entries.length + '</span></button>' : '')
      + '<p class="ykf-foot__err" hidden></p>'
      + '<div class="ykf-foot__row">'
      +   '<span class="ykf-foot__hint">Enregistrés sur cet appareil</span>'
      +   '<button type="button" class="ykf-foot__clear" data-ykf-clear>' + (clearArmed ? 'Confirmer ?' : 'Vider les favoris') + '</button>'
      + '</div>';
  }
  function render() {
    var body = document.getElementById('ykfBody');
    if (!body) return;
    var entries = readStore();
    var badge = document.getElementById('ykfC');
    if (badge) badge.textContent = entries.length;
    renderFoot(entries);
    if (!entries.length) { body.innerHTML = emptyHtml(); return; }
    body.innerHTML = entries.map(function (e) { return itemHtml(e, productCache[e.handle] || null); }).join('');
    entries.forEach(function (entry) {
      if (productCache[entry.handle]) return;
      fetchProduct(entry.handle).then(function (product) {
        if (!isOpen()) return;
        var fresh = findEntry(readStore(), entry.handle);
        if (fresh) replaceItem(fresh, product);
      }).catch(function (err) {
        /* 404 uniquement (produit supprimé / dépublié) : retiré des favoris.
           Toute autre erreur (hors-ligne, abort, 401/403/5xx/429, timeout) : l'entrée est conservée avec ses
           métadonnées mémorisées (titre / image / prix) — rien n'est supprimé. */
        if (err && err.status === 404) {
          remove(entry.handle);
          if (isOpen()) render();
        }
      });
    });
  }
  function replaceItem(entry, product) {
    var body = document.getElementById('ykfBody');
    if (!body) return;
    var node = body.querySelector('[data-ykf-handle="' + cssEscape(entry.handle) + '"]');
    if (!node) return;
    var wrap = document.createElement('div');
    wrap.innerHTML = itemHtml(entry, product || productCache[entry.handle] || null);
    node.replaceWith(wrap.firstChild);
  }
  function reRenderItem(handle) {
    var e = findEntry(readStore(), handle);
    if (e) replaceItem(e, productCache[handle] || null);
  }
  function itemNode(handle) {
    var body = document.getElementById('ykfBody');
    return body ? body.querySelector('[data-ykf-handle="' + cssEscape(handle) + '"]') : null;
  }
  function showItemError(handle, msg) {
    var node = itemNode(handle); if (!node) return;
    var err = node.querySelector('.ykf-item__err');
    if (err) { err.textContent = msg; err.hidden = false; }
  }

  /* ---------------- ouverture / fermeture ---------------- */
  function isOpen() { var d = document.getElementById('ykfD'); return !!(d && d.classList.contains('on')); }
  function open() {
    var drawer = document.getElementById('ykfD'), overlay = document.getElementById('ykfO');
    if (!drawer || !overlay) return;
    if (window.ykCart && typeof window.ykCart.close === 'function') { try { window.ykCart.close(); } catch (e) {} }
    clearArmed = 0;
    render();
    if (drawer.classList.contains('on')) return;
    lastFocus = document.activeElement;
    drawer.classList.add('on');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('on');
    document.body.classList.add('ykf-lock');
    var x = drawer.querySelector('.ykf-x');
    if (x) setTimeout(function () { try { x.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function close() {
    var drawer = document.getElementById('ykfD'), overlay = document.getElementById('ykfO');
    if (!drawer || !drawer.classList.contains('on')) { document.body.classList.remove('ykf-lock'); return; }
    drawer.classList.remove('on');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('on');
    document.body.classList.remove('ykf-lock');
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    lastFocus = null;
  }

  /* ---------------- panier ---------------- */
  /* lignes Shopify pour un favori (même format que ykCart.confirmAdd) */
  function buildItems(entry, product) {
    var cfg = entry.config, ids = cartIds();
    var variant = pickVariant(product, cfg.sz);
    if (!variant) return null;
    var ref = newRef(), title = product.title || entry.title || entry.handle;
    var props = { 'Taille': cfg.sz, '_yk_ref': ref };
    var name = cfg.floc ? cfg.name.trim().toUpperCase() : '', num = cfg.floc ? cfg.num.trim() : '', sub = cfg.floc ? cfg.sub.trim().toUpperCase() : '';
    var shortSz = cfg.short ? (cfg.shortSz || cfg.sz) : '';
    if (name) props['Nom'] = name;
    if (num) props['Numéro'] = num;
    if (sub) props['Sous-numéro'] = sub;
    if (cfg.short) props['Short assorti'] = 'Taille ' + shortSz;
    if (cfg.vplayer) props['Version Player'] = 'Oui';
    var items = [{ id: parseInt(variant.id, 10), quantity: 1, properties: props }];
    if (ids.floc) {
      if (name) items.push({ id: ids.floc, quantity: 1, properties: { 'Pour': title, 'Texte': name, '_yk_ref': ref, '_yk_addon': '1' } });
      if (num) items.push({ id: ids.floc, quantity: 1, properties: { 'Pour': title, 'Numéro': num, '_yk_ref': ref, '_yk_addon': '1' } });
      if (sub) items.push({ id: ids.floc, quantity: 1, properties: { 'Pour': title, 'Texte': sub, 'Position': 'Sous le numéro', '_yk_ref': ref, '_yk_addon': '1' } });
    }
    if (cfg.short && ids.short) items.push({ id: ids.short, quantity: 1, properties: { 'Pour': title, 'Taille': shortSz, '_yk_ref': ref, '_yk_addon': '1' } });
    if (cfg.vplayer && ids.vplayer) items.push({ id: ids.vplayer, quantity: 1, properties: { 'Pour': title, '_yk_ref': ref, '_yk_addon': '1' } });
    return items;
  }
  /* envoie les lignes au panier via ykCart (file d'attente + rendu de section) ; résout {ok, message} */
  function pushToCart(items) {
    var cart = window.ykCart;
    if (cart && typeof cart.addItems === 'function' && typeof cart.run === 'function') {
      var result = { ok: false, message: '' };
      return cart.run(function () {
        return cart.addItems(items).then(function (r) {
          if (!r.ok) { var j = r.data || {}; result.message = j.description || j.message || ''; throw new Error(result.message || 'add failed'); }
          result.ok = true;
          return r.render;
        });
      }, 'favAdd').then(function () { return result; }, function () { return result; });
    }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, message: (j && (j.description || j.message)) || '' }; }); })
      .then(function (res) {
        if (res.ok && cart && typeof cart.refresh === 'function') { try { return Promise.resolve(cart.refresh(true)).then(function () { return res; }, function () { return res; }); } catch (e) {} }
        return res;
      });
  }
  function openCart() {
    if (window.ykCart && typeof window.ykCart.open === 'function') { try { window.ykCart.open(); } catch (e) {} }
    else window.location.href = '/cart';
  }
  function addToCart(handle) {
    handle = String(handle || '').toLowerCase();
    if (busy[handle]) return Promise.resolve(false);
    var entry = findEntry(readStore(), handle);
    if (!entry) return Promise.resolve(false);
    if (!entry.config.sz) { showItemError(handle, 'Choisis une taille'); return Promise.resolve(false); }
    busy[handle] = true; reRenderItem(handle);
    return fetchProduct(handle).then(function (product) {
      if (!product.available) throw new Error('Ce maillot est épuisé');
      var items = buildItems(entry, product);
      if (!items) throw new Error('Variante introuvable');
      return pushToCart(items);
    }).then(function (res) {
      delete busy[handle];
      if (!res.ok) { reRenderItem(handle); showItemError(handle, res.message || 'Erreur lors de l’ajout, réessaie'); return false; }
      close();
      openCart();
      return true;
    }).catch(function (e) {
      delete busy[handle];
      reRenderItem(handle);
      var msg = (e && e.message) || '';
      if (e && typeof e.status === 'number') msg = e.status === 404 ? 'Ce maillot n’est plus disponible' : 'Impossible de charger ce maillot, réessaie';
      showItemError(handle, msg || 'Erreur lors de l’ajout, réessaie');
      return false;
    });
  }
  function addAll() {
    var entries = readStore();
    if (!entries.length) return Promise.resolve(false);
    var foot = document.getElementById('ykfFoot');
    var err = foot && foot.querySelector('.ykf-foot__err');
    var missing = entries.filter(function (e) { return !e.config.sz; });
    if (missing.length) {
      missing.forEach(function (e) { var n = itemNode(e.handle); if (n) { n.classList.remove('need'); void n.offsetWidth; n.classList.add('need'); } });
      if (err) { err.textContent = 'Choisis une taille pour chaque maillot (' + missing.length + ' manquante' + (missing.length > 1 ? 's' : '') + ')'; err.hidden = false; }
      var first = itemNode(missing[0].handle);
      if (first && first.scrollIntoView) first.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      return Promise.resolve(false);
    }
    var btn = foot && foot.querySelector('[data-ykf-add-all]');
    if (btn) { btn.disabled = true; btn.classList.add('busy'); }
    if (err) err.hidden = true;
    return Promise.all(entries.map(function (e) {
      return fetchProduct(e.handle).then(
        function (p) { return { entry: e, product: p }; },
        function (err) { return { entry: e, product: null, error: err || new Error('fetch failed') }; }
      );
    }))
      .then(function (rows) {
        /* un fetch en échec (réseau, 5xx, 401…) n'est jamais ignoré : on n'ouvre pas le panier comme si tout
           était ajouté — message dans .ykf-foot__err et aucune ligne envoyée. (404 = produit disparu, ignoré) */
        var failed = rows.filter(function (r) { return r.error && !(r.error.status === 404); });
        if (failed.length) {
          var e = new Error('Impossible de charger ' + failed.length + ' maillot' + (failed.length > 1 ? 's' : '') + ', réessaie');
          e.loadFailed = failed.length;
          throw e;
        }
        var items = [];
        rows.forEach(function (r) { if (r && r.product && r.product.available) { var it = buildItems(r.entry, r.product); if (it) items = items.concat(it); } });
        if (!items.length) throw new Error('Aucun maillot disponible');
        return pushToCart(items);
      })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.classList.remove('busy'); }
        if (!res.ok) { if (err) { err.textContent = res.message || 'Erreur lors de l’ajout, réessaie'; err.hidden = false; } return false; }
        close();
        openCart();
        return true;
      })
      .catch(function (e) {
        if (btn) { btn.disabled = false; btn.classList.remove('busy'); }
        if (err) { err.textContent = (e && e.message) || 'Erreur lors de l’ajout, réessaie'; err.hidden = false; }
        return false;
      });
  }

  /* ---------------- synchro boutons / compteurs ---------------- */
  function syncToggleEl(el) {
    var handle = el.getAttribute('handle') || el.dataset.handle;
    if (!handle) return;
    var active = has(handle);
    el.classList.toggle('is-active', active);
    var btn = el.querySelector('button, [role="button"]');
    if (btn) {
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var labelOn = el.getAttribute('label-on') || 'Retirer des favoris';
      var labelOff = el.getAttribute('label-off') || 'Ajouter aux favoris';
      btn.setAttribute('aria-label', active ? labelOn : labelOff);
      var labelEl = btn.querySelector('[data-ykfav-label]');
      if (labelEl) labelEl.textContent = active ? labelOn : labelOff;
    }
  }
  function syncAllToggles() { document.querySelectorAll('ykfav-toggle, [data-ykfav-toggle]').forEach(syncToggleEl); }
  function syncCount(bump) {
    var n = count();
    document.querySelectorAll('ykfav-count, [data-ykfav-count]').forEach(function (el) {
      var prev = el.textContent;
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
      if (bump && n > 0 && String(prev) !== String(n)) {
        el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
      }
    });
    var c = document.getElementById('ykfC'); if (c) c.textContent = n;
  }
  function initialSync() { syncAllToggles(); syncCount(false); }

  /* ---------------- évènements ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var openTrigger = t.closest('[data-ykfav-open]');
    if (openTrigger) { e.preventDefault(); open(); return; }
    var closeTrigger = t.closest('[data-ykfav-close]');
    if (closeTrigger) { e.preventDefault(); close(); return; }

    var toggleTrigger = t.closest('[data-ykfav-handle]');
    if (toggleTrigger && (toggleTrigger.tagName === 'BUTTON' || toggleTrigger.getAttribute('role') === 'button')) {
      e.preventDefault(); e.stopPropagation();
      var handle = toggleTrigger.getAttribute('data-ykfav-handle');
      var wrap = toggleTrigger.closest('ykfav-toggle, [data-ykfav-toggle]');
      /* La configuration du configurateur (taille, flocage, short, Player) n'est reprise QUE pour le produit de
         la fiche (bouton injecté sous l'ATC, ou handle = celui de l'URL). Les cœurs des cartes « récemment vus »
         / recommandations affichés sur la même page enregistrent la config par défaut. */
      var m = (window.location.pathname || '').match(/\/products\/([^\/?#]+)/);
      var pageHandle = '';
      if (m) { try { pageHandle = decodeURIComponent(m[1]).toLowerCase(); } catch (x) { pageHandle = String(m[1]).toLowerCase(); } }
      var isPageProduct = !!toggleTrigger.closest('[data-ykfav-injected]') || (!!pageHandle && pageHandle === String(handle || '').trim().toLowerCase());
      var added = toggle(handle, {
        title: toggleTrigger.getAttribute('data-ykfav-title') || '',
        image: toggleTrigger.getAttribute('data-ykfav-image') || '',
        config: isPageProduct ? (readPdpConfig() || defaultConfig()) : defaultConfig()
      });
      if (wrap) { wrap.classList.remove('pop'); void wrap.offsetWidth; if (added) wrap.classList.add('pop'); }
      return;
    }

    var drawer = t.closest('#ykfD');
    if (!drawer) return;

    var rm = t.closest('[data-ykf-remove]');
    if (rm) {
      e.preventDefault();
      var h = rm.getAttribute('data-ykf-remove'), node = itemNode(h);
      if (node) { node.classList.add('removing'); setTimeout(function () { remove(h); render(); }, 180); }
      else { remove(h); render(); }
      return;
    }
    var addBtn = t.closest('[data-ykf-add]');
    if (addBtn) { e.preventDefault(); if (!addBtn.disabled) addToCart(addBtn.getAttribute('data-ykf-add')); return; }
    if (t.closest('[data-ykf-add-all]')) { e.preventDefault(); addAll(); return; }
    var clr = t.closest('[data-ykf-clear]');
    if (clr) {
      e.preventDefault();
      if (clearArmed) { clearArmed = 0; clear(); render(); return; }
      clearArmed = 1; clr.textContent = 'Confirmer ?'; clr.classList.add('armed');
      setTimeout(function () { if (clearArmed && document.contains(clr)) { clearArmed = 0; clr.textContent = 'Vider les favoris'; clr.classList.remove('armed'); } }, 4000);
      return;
    }
    var panel = t.closest('[data-ykf-panel]');
    if (panel) {
      e.preventDefault();
      var ph = panel.getAttribute('data-ykf-panel');
      openPanels[ph] = !openPanels[ph];
      var box = panel.nextElementSibling;
      if (box && box.classList.contains('ykf-panel')) box.hidden = !openPanels[ph];
      panel.setAttribute('aria-expanded', openPanels[ph] ? 'true' : 'false');
      return;
    }
    var sizeBtn = t.closest('[data-ykf-size]');
    if (sizeBtn) {
      e.preventDefault();
      var sh = sizeBtn.getAttribute('data-ykf-h'), sz = sizeBtn.getAttribute('data-ykf-size'), cur = getConfig(sh);
      var patch = { sz: sz };
      if (cur.short && (!cur.shortSz || cur.shortSz === cur.sz)) patch.shortSz = sz;
      patchEntry(sh, patch, true); reRenderItem(sh); return;
    }
    var shortSize = t.closest('[data-ykf-short-size]');
    if (shortSize) { e.preventDefault(); var ssh = shortSize.getAttribute('data-ykf-h'); patchEntry(ssh, { shortSz: shortSize.getAttribute('data-ykf-short-size') }, true); reRenderItem(ssh); return; }
    var flocSw = t.closest('[data-ykf-floc-switch]');
    if (flocSw) {
      e.preventDefault();
      var fh = flocSw.getAttribute('data-ykf-floc-switch'), fc = getConfig(fh), on = !fc.floc;
      patchEntry(fh, on ? { floc: true } : { floc: false, name: '', num: '', sub: '' }, true); reRenderItem(fh);
      if (on) { var n = itemNode(fh), inp = n && n.querySelector('[data-ykf-floc-field="name"]'); if (inp) { try { inp.focus({ preventScroll: true }); } catch (x) {} } }
      return;
    }
    var shortSw = t.closest('[data-ykf-short-switch]');
    if (shortSw) {
      e.preventDefault();
      var sh2 = shortSw.getAttribute('data-ykf-short-switch'), sc = getConfig(sh2), son = !sc.short;
      patchEntry(sh2, { short: son, shortSz: son ? (sc.shortSz || sc.sz) : '' }, true); reRenderItem(sh2); return;
    }
    var vpSw = t.closest('[data-ykf-vplayer-switch]');
    if (vpSw) { e.preventDefault(); var vh = vpSw.getAttribute('data-ykf-vplayer-switch'); patchEntry(vh, { vplayer: !getConfig(vh).vplayer }, true); reRenderItem(vh); return; }
  }, false);

  /* champs flocage : mémorisés à la frappe, total et résumé mis à jour sans perdre le focus */
  function onFlocInput(e) {
    var input = e.target && e.target.closest && e.target.closest('[data-ykf-floc-field]');
    if (!input) return;
    var h = input.getAttribute('data-ykf-h'), patch = {};
    patch[input.getAttribute('data-ykf-floc-field')] = input.value;
    patchEntry(h, patch, true);
    var node = itemNode(h); if (!node) return;
    var entry = findEntry(readStore(), h); if (!entry) return;
    var product = productCache[h] || null, cfg = entry.config;
    var add = node.querySelector('.ykf-add');
    if (add && cfg.sz && (!product || product.available)) { var tot = itemTotal(entry, product, cfg); add.textContent = 'Ajouter au panier' + (tot > 0 ? ' · ' + money(tot) : ''); }
    var sum = node.querySelector('.ykf-item__sum'); if (sum) sum.textContent = optionsSummary(cfg);
  }
  document.addEventListener('input', onFlocInput, false);
  document.addEventListener('change', onFlocInput, false);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) { e.preventDefault(); close(); }
  });
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) { syncAllToggles(); syncCount(false); if (isOpen()) render(); }
  });
  document.addEventListener('ykfav:change', function () {
    syncAllToggles();
    syncCount(true);
    if (isOpen()) { var c = document.getElementById('ykfC'); if (c) c.textContent = count(); }
  });

  /* ---------------- API exportée ---------------- */
  window.ykFav = {
    add: add, remove: remove, toggle: toggle, has: has, count: count, list: list, clear: clear,
    open: open, close: close, isOpen: isOpen, render: render, refresh: render,
    addToCart: addToCart, addAll: addAll, getConfig: getConfig
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialSync);
  else initialSync();

  /* éléments ajoutés plus tard (header, sections re-rendues, cartes chargées en AJAX) : synchro différée */
  var syncScheduled = false;
  function scheduleSync() {
    if (syncScheduled) return;
    syncScheduled = true;
    requestAnimationFrame(function () { syncScheduled = false; initialSync(); injectProductFavButton(); });
  }
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType !== 1) continue;
        if (n.closest && n.closest('#ykfD')) continue; // nos propres rendus
        scheduleSync(); return;
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  /* ---------------- bouton « Ajouter aux favoris » sous l'ATC du configurateur produit ----------------
     Le bloc buy_buttons (qui rend snippets/yk-favorite-button) est désactivé dans product.json : le bouton est
     injecté après #ykAddBtn, une seule fois (marqueur data-ykfav-spacer). */
  function getProductMetaFromPage() {
    var m = (window.location.pathname || '').match(/\/products\/([^\/?#]+)/);
    if (!m) return null;
    var handle = decodeURIComponent(m[1]).toLowerCase();
    var titleEl = document.querySelector('.product-info__title, h1.product__title, [itemprop="name"], h1');
    var title = titleEl ? titleEl.textContent.trim() : '';
    if (!title) { var og = document.querySelector('meta[property="og:title"]'); if (og) title = og.getAttribute('content') || ''; }
    var image = '';
    var ogImg = document.querySelector('meta[property="og:image"], meta[property="og:image:secure_url"]');
    if (ogImg) image = ogImg.getAttribute('content') || '';
    if (!image) { var img = document.querySelector('.product-gallery__media img, .product__media img, .product-info img'); if (img) image = img.currentSrc || img.src || ''; }
    return { handle: handle, title: title, image: normImage(image) };
  }
  function buildFavButton(meta) {
    var wrap = document.createElement('ykfav-toggle');
    wrap.className = 'ykf-toggle ykf-toggle--full';
    wrap.setAttribute('handle', meta.handle);
    wrap.setAttribute('label-on', 'Retirer des favoris');
    wrap.setAttribute('label-off', 'Ajouter aux favoris');
    wrap.setAttribute('data-ykfav-injected', '1');
    wrap.innerHTML = ''
      + '<button type="button" class="ykf-toggle__btn" aria-pressed="false" aria-label="Ajouter aux favoris"'
      +   ' data-ykfav-handle="' + escapeHtml(meta.handle) + '"'
      +   ' data-ykfav-title="' + escapeHtml(meta.title) + '"'
      +   ' data-ykfav-image="' + escapeHtml(meta.image) + '">'
      +   '<svg class="ykf-heart" viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>'
      +   '<span data-ykfav-label>Ajouter aux favoris</span>'
      + '</button>';
    return wrap;
  }
  function injectProductFavButton() {
    if (!/\/products\//.test(window.location.pathname)) return;
    var atc = document.querySelector('#ykAddBtn, .yk-add-btn');
    if (!atc || !atc.parentNode) return;
    if (atc.parentNode.querySelector(':scope > [data-ykfav-spacer="1"]')) return;
    var meta = getProductMetaFromPage();
    if (!meta || isHiddenHandle(meta.handle)) return;
    var spacer = document.createElement('div');
    spacer.setAttribute('data-ykfav-spacer', '1');
    spacer.className = 'ykf-pdp-slot';
    var btn = buildFavButton(meta);
    spacer.appendChild(btn);
    atc.parentNode.insertBefore(spacer, atc.nextSibling);
    syncToggleEl(btn);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', injectProductFavButton);
  else injectProductFavButton();
  setTimeout(injectProductFavButton, 600);
  setTimeout(injectProductFavButton, 2000);
})();
